import { createAction } from 'typesafe-actions';

export const selectAddress = createAction('@SELECT_ADDRESS')<
  GQL.IConfirmationInfo | null
>();